<template>
    <div class="tyn-aside tyn-aside-base">
        <div class="tyn-aside-head">
            <div class="tyn-aside-head-text">
                <h3 class="tyn-aside-title tyn-title">Histórico</h3>
            </div>
            <div class="tyn-aside-head-tools">
                <ul class="tyn-list-inline gap gap-3">
                    <li>
                        <button class="btn btn-icon btn-success-add btn-md btn-pill"
                                @click="criarNovo"
                                title="Novo"
                                style="background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important; border: none !important;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                            </svg>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tyn-aside-body" data-simplebar>
            <div class="tyn-aside-search">
                <div class="search-box-modern">
                    <div class="search-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                        </svg>
                    </div>
                    <input
                        type="text"
                        class="search-input-modern"
                        id="search-analisadores"
                        placeholder="Pesquisar no histórico..."
                        v-model="dsFiltro"
                        v-on:keyup.enter="load"
                        @focusout="load"
                    >
                </div>
            </div>
            <div class="tyn-aside-body" data-simplebar>
                <ul class="tyn-aside-list">
                    <li :class="'tyn-aside-item js-toggle-main '+(item.idProcessoResearch == id?'active':'')"
                        v-for="(item,index) in lstProcessoResearch"
                        :key="index"
                        @click="(event) => selecionar(event, item.idProcessoResearch)"
                        data-bs-toggle="popover"
                        data-bs-placement="right"
                        title="Detalhes"
                        :data-bs-content="getDataBsProcessoResearch(item)">
                        <div class="tyn-media-group">
                            <div class="tyn-media tyn-size-sm">
                                <img class="img-icone-historico" src="assets/images/sollai/icone-processosinteligentes.png" alt="Analisadores de Processos">
                            </div>
                            <div class="tyn-media-col">
                                <div class="content">{{item.dsNome}}</div>
                            </div>
                            <div class="tyn-media-option">
                                <ul class="tyn-media-option-list">
                                    <li>
                                        <button class="btn btn-icon btn-md btn-pill btn-light" @click="verificaExcluir(item.idProcessoResearch)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                            </svg>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tyn-aside-foot">
            <div class="w-100">
                <ul class="row justify-content-center gx-3">
                    <li class="col-12">
                        <template v-if="utilizacoes">
                            <p class="px-3 mb-1 text-center">
                                Total Analisadores: <span class="text-muted">{{utilizacoes.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoes.qtdLiberados}}</span>
                            </p>
                            <div class="px-3">
                                <div class="progress mt-1 custom-progress">
                                    <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentual+'%'}"
                                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentual}}</div>
                                </div>
                            </div>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'HistoricoAnalisadores',
        props: {
            seleciona: Function,
            reload: Boolean,
            novo: Function,
            id: Number,
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                lstProcessoResearch: [],
                dsFiltro: null,
                utilizacoes: null,
                percentual: 100,
                txtPercentual: 'Ilimitado',
            }
        },
        methods: {
            load() {
                this.carregaHistorico();
                this.carregaUtilizacoes();
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoResearch/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            // Quando houver limite contratual, calcular percentual:
                            // if ($this.utilizacoes.qtdLiberados != 'Ilimitado') {
                            //     try {
                            //         $this.percentual = parseInt(parseInt($this.utilizacoes.qtdRealizados) * 100 / parseInt($this.utilizacoes.qtdLiberados));
                            //         $this.txtPercentual = $this.percentual + '%';
                            //     } catch {
                            //         $this.percentual = 0;
                            //         $this.txtPercentual = '';
                            //     }
                            // } else {
                            //     $this.percentual = 100;
                            //     $this.txtPercentual = 'Ilimitado';
                            // }
                            $this.percentual = 100;
                            $this.txtPercentual = 'Ilimitado';
                            if (!$this.utilizacoes.qtdLiberados) {
                                $this.utilizacoes.qtdLiberados = 'Ilimitado';
                            }
                        }
                    })
                    .catch(() => { });
            },

            getDataBsProcessoResearch(item) {
                return ` <span class="mb-0"><strong>Tipo:</strong> ${item.nmTipoResearch}</span>
                 <span class="mb-0"><strong>Data:</strong> ${item.dtInclusao}</span>
                `;
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                });
                            });
                    }
                });
            },

            carregaHistorico() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoResearch/Get`, { showLoading: false, params: { dsTermo: this.dsFiltro } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstProcessoResearch = [];
                            const resultado = res.data.data.resultados;
                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];

                                var status = '';
                                if (item.lstProcessoResearchMovimento.length > 0) {
                                    status = item.lstProcessoResearchMovimento[item.lstProcessoResearchMovimento.length - 1].dsMovimento;
                                }

                                var processoResearch = {
                                    idProcessoResearch: item.processoResearch.idProcessoResearch,
                                    dsLogin: item.processoResearch.dsLogin,
                                    usuario: item.usuario.nmUsuario,
                                    dsNome: item.processoResearch.dsNome,
                                    dtInclusao: moment(item.processoResearch.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmTipoResearch: item.tipoResearch.dsNome,
                                    status: status,
                                };

                                if ($this.user.usuario.dsLogin.trim() == processoResearch.dsLogin.trim()) {
                                    $this.lstProcessoResearch.push(processoResearch);
                                }
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas solicitações.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas solicitações.");
                        }
                    });
            },

            selecionar(e, id) {
                this.seleciona(id, 5);
                document.getElementById('tynMain').classList.toggle('main-shown');
            },

            verificaExcluir(id) {
                let $this = this;
                Swal.fire({
                    title: 'Tem certeza que deseja remover?',
                    text: 'Esta operação não poderá ser desfeita.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: '#83A431',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $this.excluir(id)
                    }
                })
            },

            excluir(id) {
                let $this = this;
                axios.delete(`${urlApi}/ProcessoResearch/Delete`, { params: { id: id } })
                    .then(res => {
                        if (res.data.success) {
                            $this.load();
                            avisoToast("Analisador removido com sucesso");
                        } else {
                            avisoErro("Não foi remover o analisador.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi remover o analisador.");
                        }
                    });
            },

            criarNovo() {
                this.novo();
                document.getElementById('tynMain').classList.toggle('main-shown');
            },
        },
        mounted: function () {
            this.load();
        },
        watch: {
            reload: function () {
                this.load();
            },
            dsFiltro: function () {
                if (this.dsFiltro.length > 3) {
                    this.load();
                } else {
                    if (this.dsFiltro == "") {
                        this.load();
                    }
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .img-icone-historico {
        max-width: 20px;
        height: auto;
    }

    [data-bs-theme=dark] .img-icone-historico {
        filter: invert(1)
    }

    .btn-success-add {
        background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important;
        color: white !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn-success-add:hover,
    .btn-success-add:focus,
    .btn-success-add:active {
        background: linear-gradient(135deg, #1d4ed8 0%, #00bf51 100%) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35) !important;
        color: white !important;
        border-color: transparent !important;
    }

    .btn-success-add svg {
        fill: white !important;
    }

    .tyn-aside-search {
        padding: 0.75rem 1rem;
        margin-bottom: 0.5rem;
    }

    .search-box-modern {
        position: relative;
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 14px;
        padding: 0.65rem 1rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
            border-color: rgba(31, 123, 255, 0.3);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:focus-within {
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.2);
            transform: translateY(-2px);
            background: #ffffff;
        }
    }

    .search-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
        flex-shrink: 0;
        color: #6c757d;
    }

    .search-input-modern {
        flex: 1;
        border: none;
        background: transparent;
        outline: none;
        padding: 0.25rem 0;
        font-size: 0.95rem;
        color: #2d3748;
        font-weight: 500;

        &::placeholder {
            color: #a0aec0;
            font-weight: 400;
        }
    }

    .tyn-aside-item {
        border-radius: 10px;
        margin-bottom: 0.5rem;
        padding: 0.75rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        cursor: pointer;

        &:hover {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
            border-color: rgba(31, 123, 255, 0.15);
            transform: translateX(4px);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

            .content {
                color: #1f7bff;
            }
        }

        &.active {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.12) 0%, rgba(0, 208, 132, 0.12) 100%);
            border-color: #1f7bff;
            box-shadow: 0 3px 10px rgba(31, 123, 255, 0.2);
            transform: translateX(6px);

            .content {
                color: #1f7bff;
                font-weight: 600;
            }
        }
    }

    .content {
        font-size: 0.9rem;
        line-height: 1.4;
        color: #2d3748;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .tyn-media-group {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .tyn-media {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        border-radius: 8px;
    }

    .btn-pill.btn-light {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid #e9ecef;

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            border-color: transparent;
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);

            svg {
                fill: white !important;
            }
        }
    }

    :deep(.custom-popover) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }
    }

    [data-bs-theme="dark"] .search-box-modern {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
    }

    [data-bs-theme="dark"] .search-input-modern {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .tyn-aside-item .content {
        color: #cbd5e1;
    }

    .progress-bar-color {
        color: white;
        background: rgb(0, 81, 173);
        background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
    }

    .custom-progress {
        height: 25px;
    }

    .custom-progress .progress-bar {
        height: 25px;
        font-size: 1.2em;
    }

    [data-bs-theme="dark"] .custom-progress {
        background-color: #2d3748;
    }
</style>
